
import { defineComponent, onMounted, inject, ref, watch } from "vue";
import {
    getMountingsTypeTable,
    getManagementTableEdit,
    postSetMountingsType,
    postEditMountingsType,
    postAddMountingsType, permissionList,
} from "@/api/http";
export default defineComponent({
    name: "Classification",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["配件分类"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            tableData = ref([]),
            roleList = ref({} as any),
            loading = ref(true),
            dialogFormVisible = ref(false),
            dialogTitle = ref("新增分类"),
            formRef = ref(null),
            form = ref({
                name: "",
                sort: 1,
                id: 0,
            }),
            father = ref({ id: 0, name: null }),
            isEdit = ref(false);
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'classification',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                let data = {
                    page: currentPage.value,
                    pagesize: pageSize.value,
                };
                getMountingsTypeTable(data).then((res: any) => {
                    if (res.status == 200) {
                        tableData.value = res.content.list;
                      console.log(res.content.list)
                        loading.value = false;
                        total.value = res.content.count;
                    }
                });
            },
            getChildrenTableData = () => {
                loading.value = true;
                let data = {
                    page: 1,
                    pagesize: 10,
                    pid: father.value.id,
                };
                getMountingsTypeTable(data).then((res: any) => {
                    if (res.status == 200) {
                        tableData.value = res.content.list;
                        loading.value = false;
                    }
                });
            },
            columnChange = (item: any, index: number): void => {
                switch (index) {
                    case 0:
                        dialogTitle.value = "编辑分类";
                        isEdit.value = true;
                        dialogFormVisible.value = true;
                        form.value.name = item.name;
                        form.value.sort = item.sort;
                        form.value.id = item.id;
                        break;
                    case 1:
                        father.value = item;
                        getChildrenTableData();
                        break;
                    case 2:
                        postSetMountingsType({
                            id: item.id,
                            status: item.status == 0 ? 1 : 0,
                        }).then((res) =>
                            father.value.name
                                ? getChildrenTableData()
                                : getTableData()
                        );
                        break;
                }
            },
            back = () => {
                father.value = { id: 0, name: null };
                getTableData();
            },
            submitForm = () => {
                (formRef.value as any).validate(async (valid: boolean) => {
                    if (valid) {
                        let data: {
                            name: string;
                            sort: number;
                            id?: number;
                            pid?: number;
                        } = {
                            name: form.value.name,
                            sort: form.value.sort,
                        };
                        father.value.name && (data["pid"] = father.value.id);
                        if (isEdit.value) {
                            data["id"] = form.value.id;
                            await postEditMountingsType(data).then(
                                (res) =>
                                    (dialogFormVisible.value =
                                        res.status != 202)
                            );
                        } else {
                            await postAddMountingsType(data).then(
                                (res) =>
                                    (dialogFormVisible.value =
                                        res.status != 202)
                            );
                        }
                        if (father.value.name && !dialogFormVisible.value) {
                            getChildrenTableData();
                        } else {
                            getTableData();
                        }
                    }
                });
            };
        onMounted(() => {
            getTableData();
        });
        watch(dialogFormVisible, (newValue, oldValue) => {
            if (oldValue) {
                (formRef.value as any).resetFields();
                form.value = {
                    name: "",
                    sort: 1,
                    id: 0,
                };
                isEdit.value = false;
                                dialogTitle.value = "新增分类";
                (formRef.value as any).resetFields();
            }
        });

        return {
            headClass,
            pageSize,
            currentPage,
            total,
            tableData,
            loading,
            dialogFormVisible,
            dialogTitle,
            formRef,
            form,
            father,
            isEdit,
            handleSizeChange,
            handleCurrentChange,
            columnChange,
            submitForm,
            back,
            roleList,
        };
    },
});
